import { render, staticRenderFns } from "./baseContent.vue?vue&type=template&id=0f7d87e6&"
import script from "./baseContent.vue?vue&type=script&lang=js&"
export * from "./baseContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports